<div class="app-container app-theme-white body-tabs-shadow fixed-header fixed-sidebar">
    <app-header></app-header>
    <div class="app-main">
        <!-- Menu Section -->
        <app-menus></app-menus>
        <!-- Menu section End -->
        <div class="app-main__outer">
            <div class="app-main__inner">
                <div class="title_page_main">
                    <div class="titleinner">Complaint Details</div>
                    <div class="titlerightbutton">
                        <button type="button" class="btn btn-primary" style="float: right;"
                            (click)="goBack()">Back</button>
                    </div>
                </div>

                <div class="main-card card mb-3 main-card mb-3 card cardmaininner" style="width: 100%;">
                    <div class="row pl-0 pr-0">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-6">
                                    <table class="table table-bordered" style="margin: 10px;">
                                        <tbody>
                                            <tr>
                                                <th style="width:10% !important;text-align: left;"><strong>Complaint
                                                        ID</strong></th>
                                                <td style="width:10% !important;text-align: left;">
                                                    {{viewData?.task_number}}</td>
                                            </tr>
                                            <tr>
                                                <th style="width:10% !important;text-align: left;"> <strong>Complaint
                                                        Date</strong></th>
                                                <td style="width:10% !important;text-align: left;">{{viewData?.created_at
                                                    | date:'dd-MM-yyyy'}}</td>
                                            </tr>
                                            <tr>
                                                <th style="width:10% !important;text-align: left;"><strong>Machine
                                                        Type</strong></th>
                                                <td style="width:10% !important;text-align: left;">
                                                    {{viewData?.machineType != null ? viewData?.machineType : '-' }}</td>
                                            </tr>
                                            <tr>
                                                <th style="width:10% !important;text-align: left;"><strong>Assing
                                                        Engineering Name</strong></th>
                                                        <td style="width:10% !important;text-align: left;">
                                                            {{viewData?.employee_master?.first_name && viewData?.employee_master?.last_name ?
                                                              viewData?.employee_master?.first_name + ' ' + viewData?.employee_master?.last_name :
                                                              viewData?.employee_master?.first_name ? viewData?.employee_master?.first_name :
                                                              viewData?.employee_master?.last_name ? viewData?.employee_master?.last_name :
                                                              '-'}}
                                                        </td>
                                                        
                                            </tr>
                                            <tr>
                                                <th style="width:10% !important;text-align: left;"><strong>Assing
                                                        Engineering E-Mail</strong></th>
                                                <td style="width:10% !important;text-align: left;">
                                                    {{viewData?.employee_master?.official_email_id != null ?
                                                    viewData?.employee_master?.official_email_id :
                                                    '-' }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-md-6">
                                    <table class="table table-bordered" style="margin: 10px; width: 96%;">
                                        <tbody>
                                            <tr>
                                                <th style="width:10% !important;text-align: left;"> <strong>Latest
                                                        Status</strong></th>
                                                <td style="width:10% !important;text-align: left;">{{ viewData?.status ==
                                                    1 ? 'Open' : viewData?.status == 2 ? 'WIP' :
                                                    viewData?.status ==
                                                    3 ? 'Completed' : viewData?.status == 4 ? 'Cancelled' :
                                                    viewData?.status == 15 ?
                                                    'Closed' : viewData?.status == 7 ? "Rejected":'-' }}</td>
                                            </tr>
                                            <tr>
                                                <th style="width:10% !important;text-align: left;"> <strong>Party
                                                        Name</strong></th>
                                                <td style="width:10% !important;text-align: left;">
                                                    {{viewData?.customer?.name}}</td>
                                            </tr>

                                            <tr>
                                                <th style="width:10% !important;text-align: left;"><strong>Complaint
                                                        Description</strong></th>
                                                <td style="width:10% !important;text-align: left;">
                                                    <div [innerHTML]="viewData?.issue_details"></div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <table class="table table-bordered" style="margin: 10px; width: 98%;">
                                <tr>
                                    <td><strong>Attachements</strong></td>
                                    <td>
                                        <!-- Rajesh - will remove commented code in next PR -->
                                        <!-- <ng-container *ngFor="let attachment of complaintAttachmentList; let i = index">
                                            <div style="display: inline-block; text-align: center; margin-right: 10px; width: 100px; word-wrap: break-word;">
                                                <a [href]="attachment.attachmentUrl" target="_blank">
                                                    <img [src]="getImagePath(attachment.attachmentUrl)" 
                                                        alt="Image {{ i + 1 }}" width="60" height="60">
                                                </a>
                                                <div style="margin-top: 5px; font-size: 12px; word-wrap: break-word; overflow-wrap: break-word; white-space: normal;">
                                                    {{ attachment.attachment }}
                                                </div>
                                            </div>
                                        </ng-container> -->
                                    


                                        <ng-container *ngFor="let attachment of complaintAttachmentList; let i = index">
                                            <div style="display: inline-block; text-align: center; margin-right: 10px; width: 100px;">
                                              <ng-container *ngIf="attachment.attachmentUrl; else fileNotFound">
                                                <a [href]="attachment.attachmentUrl" target="_blank">
                                                  <img [src]="getImagePath(attachment.attachmentUrl)"
                                                       alt="Image {{ i + 1 }}" width="60" height="60">
                                                </a>
                                                <div style="margin-top: 5px; font-size: 12px;">
                                                  {{ attachment.attachment }}
                                                </div>
                                              </ng-container>
                                              <ng-template #fileNotFound>
                                                <div style="font-size: 12px; color: red;"></div>
                                              </ng-template>
                                            </div>
                                          </ng-container>
                                          
                                    </td>
                                </tr>
                            </table>

                            <div class="dash_title">
                                <strong>Logs</strong>
                            </div>
                            <table class="table table-bordered" style="margin: 10px; width: 98%;">
                                <thead>
                                    <tr>
                                        <th scope="col">Date</th>
                                        <th scope="col">Description</th>
                                        <th scope="col">Entered By</th>
                                        <!-- <th scope="col">Handle</th> -->
                                    </tr>
                                </thead>
                                <tbody *ngFor="let complaintLog of complaintLogList">
                                    <tr>
                                        <td>{{ complaintLog?.commented_at | date:'dd-MM-yyyy HH:mm:ss' }}</td>
                                        <td>{{complaintLog?.comments}}</td>
                                        <td>{{complaintLog.commentedBy?.first_name}} {{complaintLog.commentedBy?.last_name}}</td>
                                        <!-- <td>{{complaintLog.commented_at}}</td> -->
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>